// extracted by mini-css-extract-plugin
module.exports =  {"row":"Zhb0jYXj8a7Z46vxGirn","rowLabel":"pBhDdcDIFk4WnegVnwzQ","left":"dOIReDnLq782i9odIS8P","right":"ktRfpVLDQISZ_L91D49p","tooltipIcon":"gG01js10zgYX0PWWCdnb"};